// frontend/src/services/hashService.js

const baseUrl = process.env.REACT_APP_API_BASE;

export async function verifyAccessByHash(hash, identifier, _) {
  const resp = await fetch(`${process.env.REACT_APP_API_BASE}/api/group/verify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ hash, identifier })
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    const code = data?.error || '';
    if (resp.status === 401 || code === 'ACCESS_DENIED') throw new Error(_('Invalid credentials'));
    if (resp.status === 400 && code === 'MISSING_IDENTIFIER') throw new Error(_('Please enter your email or phone'));
    if (resp.status === 400 && code === 'MISSING_HASH') throw new Error(_('Please enter your access code'));
    if (resp.status === 400 && code === 'INVALID_IDENTIFIER_FORMAT') throw new Error(_('Please check the format and try again'));
    throw new Error(_('Unexpected error. Please try again'));
  }

  return data; // { ok, role, group_id?, group_name?, owner_name? }
}
